import {defineComponent, onMounted, onUnmounted, Ref} from "vue";

export default defineComponent({
  data(){
    return {
      onClickOutListener: undefined as unknown as ((e:Event) => void | undefined)
    }
  },
  mounted() {
    const handler  = this.$attrs["onClickOut"] as (e:Event) => void;
    if(handler != null) {
      this.$data.onClickOutListener = (e)=>{
        if(!this.$el.contains(e.target)){
          handler(e)
        }
      };
      document.addEventListener('click', this.$data.onClickOutListener)
    }
  },
  destroyed() {
    document.removeEventListener("click", this.$data.onClickOutListener)
  }
})

export const onClickOut = (element: Ref<HTMLElement | undefined>, handler: (e:Event) => void) => {
  const onClickOutListener = (e: Event) => {
    if(element.value != null && !element.value.contains(e.target as Element)){
      handler(e)
    }
  }

  onMounted(() => {
    document.addEventListener('click', onClickOutListener)
  })

  onUnmounted(() => {
    document.removeEventListener("click", onClickOutListener)
  })

}
